import { render } from "./NoData.component.vue?vue&type=template&id=40eab5dd&scoped=true"
import script from "./NoData.component.vue?vue&type=script&lang=js"
export * from "./NoData.component.vue?vue&type=script&lang=js"

import "./NoData.component.vue?vue&type=style&index=0&id=40eab5dd&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eab5dd"]])

export default __exports__